<div class="nxe-view-switcher" role="group" [attr.aria-label]="'filemanager.ui.view' | translate">
    @for (item of views; track $index) {
        <button type="button" (click)="setView(item.name)" [class.active]="currentView == item.name"
                [attr.aria-pressed]="currentView == item.name">{{ viewLabel(item.name) | translate }}</button>
    }
</div>
